const writingStyle = [
  'business writer',
  'copywriter',
  'creative writer',
  'film/TV writer',
  'ghost writer',
  'journalist',
  'narrative non-fiction writer',
  'non-fiction writer',
  'novelist',
  'writing coach',
  'fiction writer',
  'structural editing',
  'copy editing',
  'other',
];

const keywords = [
  'academia',
  'activism',
  'addiction and recovery',
  'adoption/fostering',
  'Alzheimer’s disease',
  'animals',
  'arts and culture',
  'agriculture/farming',
  'ASL/Sign Language',
  'birds',
  'business',
  'Black culture',
  'Blue collar culture',
  'cats',
  'charity',
  'Christianity',
  'cinema',
  'civil rights',
  'comedy',
  'conservatism',
  'cricket',
  'crime',
  'criminals',
  'current affairs',
  'cancer',
  'Catholicism',
  'Chinese culture',
  'disability',
  'divorce',
  'dogs',
  'education',
  'entertainment',
  'entrepreneurship',
  'environmental issues',
  'engineering',
  'erotica',
  'finance',
  'fine arts',
  'food and cuisine',
  'football',
  'fashion',
  'gardening',
  'geek/nerd culture',
  'genealogy',
  'Hinduism',
  'history',
  'horses',
  'immigrant stories/immigration',
  'Islam',
  'Indian culture',
  'Korean culture',
  'Judaism',
  'literature',
  'law',
  'law enforcement',
  'LGBTQIA+',
  'liberalism',
  'libertarianism',
  'marketing',
  'marriage',
  'music',
  'medicine',
  'mental health',
  'military or military history',
  'musical theater',
  'non-profit work',
  'Native American culture',
  'New Age',
  'Nigerian culture',
  'pets',
  'politics',
  'psychology',
  'PTSD',
  'publishing',
  'Pakistani culture',
  'parenting',
  'Parkinson’s disease',
  'relationships',
  'love',
  'safari',
  'sailing',
  'science',
  'Sikhism',
  'social affairs',
  'speechwriting',
  'spirituality',
  'screenwriting',
  'self-help',
  'social work',
  'teaching',
  'technology',
  'television and film',
  'the outdoors',
  'theater',
  'therapy',
  'travel',
  'true crime',
  'weight loss and fitness',
  'women’s stories',
  'yoga',
  'wellness',
  'sport',
  'humor/humour',
  'other',
];

const comfortLevel = [
  'domestic abuse',
  'injury and illness',
  'loss of a child',
  'mental health',
  'sex and sexuality',
  'sexual abuse',
  'violence',
];

const USER = {
  gender: ['male', 'female', 'non-binary'],
  writerProfession: {
    experience: [...Array(101).keys()],
    writingStyle,
    keywords,
    comfortLevel,
  },
};

module.exports = USER;
